/** */
import { urls } from 'services/_url';
import { apiGet } from 'services/_http';

/** */
const base_url = `${urls.sales}/modules`;

export const read = async (options = {}) => {
  return await apiGet(base_url, { ...options });
};
